module.exports = __webpack_public_path__ + "img/ayuda.52f1384e.jpeg";